<template>
  <div class="vr-simulation">
    <div class="title-text">应用场景</div>
    <div class="yycj">
      <div class="item" v-for="item in modelTypes['navigation-guide']" :key="item.header">
        <img :src="item.image" alt="">
        <div class="content-title">{{ item.header }}</div>
      </div>
    </div>
    <div class="title-text">实例介绍</div>
    <div class="sljs">
      <div v-for="(item, index) in exampleDatas.ardh.example" :key="index">
        <img :src="loaderGif[index]" />
        <div class="address-list">
          <div>{{ item.title }}</div>
          <div class="address-text">{{ item.address }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import { selectCommonElement } from '@/api'
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import { asynchronousRetrieval } from '@/utils'
import { modelTypes } from '@/config';
import { exampleDatas } from '@/config/index'

const loadUrl: any = ref({})
const store = useStore()
const router = useRouter()
const casesList: any = ref({})
const loaderGif: any = ref([]);

const toDetail = (relatedHtmlId: number, title: string) => {
  router.push(`/details?relatedHtmlId=${relatedHtmlId}`)
}

onMounted(async () => {
  selectCommonElement({ columnId: 4, appId: 2 }).then((res: any) => {
    casesList.value = [...res].filter(e => e.industry == 3).sort((a, b) => (a.sortNum ?? 0) - (b.sortNum ?? 0))[0] || {}
  })

  const fays_bg: any = await asynchronousRetrieval('nfznxr-images/jjfa/fays-bg.png');
  const mlc: any = await asynchronousRetrieval('webimg/gif/mlc.gif');
  const ckzc: any = await asynchronousRetrieval('webimg/gif/ckzc.gif');
  const jqdh: any = await asynchronousRetrieval('webimg/gif/jqdh.gif');
  const zhyq: any = await asynchronousRetrieval('webimg/gif/zhyq.gif');
  loadUrl.value = { fays_bg }
  loaderGif.value.push(mlc, ckzc, jqdh, zhyq);
})
</script>
<style scoped lang="less">
.vr-simulation {
  padding-top: 64rem;
  overflow: hidden;
  width: 100vw;

  .title-text {
    font-weight: bold;
    font-size: 40rem;
    color: #000000;
  }

  .yycj {
    width: 656rem;
    margin-left: 48rem;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-top: 24rem;
    margin-bottom: 52rem;

    &>div {
      position: relative;
      width: 318rem;
      height: 204rem;
      border-radius: 16rem;
      overflow: hidden;
      margin-bottom: 20rem;

      img {
        width: 318rem;
      }

      .content-title {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 40rem;
        text-align: center;
        background: rgba(46,118,255,0.7);
        line-height: 40rem;
        font-weight: 500;
        font-size: 20rem;
        color: #FFFFFF;
      }
    }
  }

  .sljs {
    margin-top: 36rem;
    width: 656rem;
    margin-left: 48rem;
    box-sizing: border-box;

    img {
      width: 100%;
      height: auto;
      border-radius: 24rem;
    }

    .address-list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 500;
      font-size: 28rem;
      color: #414141;
      margin: 16rem 0 48rem;

      .address-text {
        position: relative;
        font-weight: 500;
        font-size: 24rem;
        color: #3D566C;

        &::before {
          content: '';
          width: 22rem;
          height: 29rem;
          position: absolute;
          left: -34rem;
          top: 0;
          background-image: url(~@/assets/images/ar-images/nav-icon.png);
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>
